import { IBaseAction } from '@bimser/core';
import _get from 'lodash/get';
import _set from 'lodash/set';
import { BaseState } from '../../../entities/BaseState';
import DmViewerInstance from './DmViewerInstance';

declare global {
	interface Window {
		__store: any;
		DmViewerAPI?: {
			instances: IDmViewerInstances;
		};
	}
}
export class DmViewerAPI {
	static get(id: string) {
		const instancesPath = ['DmViewerAPI', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			return instance;
		}
		_set(window, instancesPath, new DmViewerInstance(id));
		return _get(window, instancesPath);
	}

	static getProperties(id: string): any {
		const instancesPath = ['DmViewerAPI', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			const state: BaseState = DmViewerAPI.getStore().getState();
			if (state.Viewers && state.Viewers.items.has(id)) {
				const viewer: any = state.Viewers.items.get(id);
				return viewer;
			}
		} else {
			return null;
		}
	}

	static toEndUser() {
		return {
			get: DmViewerAPI.get,
			getProperties: DmViewerAPI.getProperties
		};
	}

	static getStore() {
		if (!window.__store) {
			throw new Error('Store cannot be null');
		}
		return window.__store;
	}

	static dispatch(action: IBaseAction<any>) {
		DmViewerAPI.getStore().dispatch(action);
	}
}

interface IDmViewerInstances {
	[index: string]: DmViewerInstance;
}

export default DmViewerAPI.toEndUser();
